import { LitElement, html, css, unsafeCSS } from "lit-element";

import broadcastLiveStatsPlayersStyles from "./broadcast-live-stats-players.scss";

import { MetricMatchModel } from "../../../models/broadcast/metricMatchModel";
import { BroadcastTemplateModel } from "../../../models/broadcast/broadcastTemplateModel";
import BroadcastMetricTypes from "../../../enums/broadcast-metric-type";
import { MetricModel } from "../../../models/broadcast/metricModel";
import CardComponentType from "../../../enums/card-component-type";
import { MetricTeamModel } from "../../../models/broadcast/metricTeamModel";

export default class BroadcastLiveStatsPlayers extends LitElement {
    private _match: MetricMatchModel;
    private _templates: BroadcastTemplateModel[]

    constructor(
        match: MetricMatchModel,
        templates: BroadcastTemplateModel[]) {
        super();

        this._match = match;
        this._templates = templates;
    }

    async firstUpdated() {

        this._templates.filter(x => x.broadcastMetricType === BroadcastMetricTypes.Team).sort((a, b) => this.textSort(a, b, 'order'));
        this._templates.map((value) => {
            value.templateItems.sort((a, b) => this.textSort(a, b, 'order'));
        });
    }

    textSort(a, b, property) {
        let aProp = a ? a[property] : 0;
        let bProp = b ? b[property] : 0;

        let returnValue = 0;

        if (aProp < bProp)
            returnValue = -1;
        else
            returnValue = 1;

        return returnValue;
    }

    renderPlayers(team: MetricTeamModel) {
        return html`

        <table class="table">

            <thead>

                <tr>
                    <th colspan=2>${team.name}</th>
                    ${this._templates.map((template) => template.broadcastMetricType === BroadcastMetricTypes.Player ? html`<th colspan=${template.templateItems.length} style="background-color:${template.color}">${template.name}</th>`: html``)}
                <tr>

                <tr>
                    <th>#</th>
                    <th>Name</th>
                    ${this._templates.map((template) => template.broadcastMetricType === BroadcastMetricTypes.Player ? 
                        html`${template.templateItems.map((templateItem) => html`<th style="background-color:${template.color}">${templateItem.name}</th>` )}` : '')}
                <tr>

            </thead>
            <tbody>

                ${team.players.map((player) => 
                    html`
                    <tr>
                        <td>${player.startingNumber}</td>
                        <td>${player.fullName}</td>

                        ${this._templates.map((template) => template.broadcastMetricType === BroadcastMetricTypes.Player ? 
                            html`${template.templateItems.map((templateItem) => { 
                                let metric = player.metrics.find(x => x.metricId === templateItem.broadcastMetricId);

                                return html`<td style="background-color:${template.color}">${metric?.value ?? '-'}</td>`})}` 
                        : '')}
                    </tr>
                    `)}


            </tbody>

        </table>`;
    }

    createRenderRoot() {
        return this;
    }

    render() {
        return [
            html`
            <style>
                ${css`${unsafeCSS(broadcastLiveStatsPlayersStyles)}`}                     
            </style>

            <div class="home-team">
                ${(this._match.teams.length > 0) ? this.renderPlayers(this._match.teams[0]) : ''}
            </div>
            <div class="away-team">
                ${(this._match.teams.length > 0) ? this.renderPlayers(this._match.teams[1]) : ''}
            </div>`
        ];
    }
}

window.customElements.define('broadcast-live-stats-players', BroadcastLiveStatsPlayers as any)